import Analytics from 'analytics';

import googleAnalytics from '@analytics/google-analytics';
import { DEFAULT_TITLE } from '@common/constants';
import { isDevMode } from '@common/utils';

const APP_NAME = (DEFAULT_TITLE + '_v2').replace(/\s+/g, '_');
/**
 * List of Google Analytics IDs by URL REGEXP
 *  Regex matches against window.location.host
 *  order matters, last item is catch all
 *  NOTE: set the ID to null to disable analytics
 * @type {Array<{ regex: RegExp, id: string }>}
 */
const GA_ID_BY_URL = [
    { regex: /\.ee\.inscyth\.com/i, id: 'G-WKPF42E35G' },
    { regex: /.*/, id: 'G-1RWN32D0RJ', debug: true }, // catch all
];

const initializeAnalytics = () => {
    try {
        const GA = GA_ID_BY_URL.find((item, index, array) => {
            return index === array.length - 1 || !item.regex || window.location.host.match(item.regex);
        });

        if (!GA?.id) {
            throw new Error('Google Analytics Measurement ID is not defined');
        }

        const debug = GA.debug || isDevMode();

        console.log('Initializing analytics with ID:', GA.id);
        // eslint-disable-next-line new-cap
        const analytics = Analytics({
            app: APP_NAME,
            debug,
            plugins: [
                googleAnalytics({
                    measurementIds: [GA.id],
                    debug,
                    gtagConfig: {
                        send_page_view: true,
                        cookie_flags: 'SameSite=None;Secure',
                    },
                }),
            ],
        });

        // Test the initialization
        if (debug) {
            console.log('Analytics initialized with ID:', GA.id, GA.regex.source);
        }

        return analytics;
    } catch (error) {
        console.error('Failed to initialize analytics:', error);

        // Return a dummy analytics instance in case of failure
        // eslint-disable-next-line new-cap
        return Analytics({
            app: APP_NAME,
            plugins: [],
        });
    }
};

export const analytics = initializeAnalytics();
